import { Expandable } from './Expandable.js'

import { trapFocus } from "./SvelteActions";

export class Footer {
    constructor(breakpoint) {
        this.$el = document.querySelector('.footer[role="contentinfo"]')
        
        this.mobileDisplayQuery = window.matchMedia(breakpoint) // while the media query is true, menu is displayed as mobile
        
        this.newsletterFormIsLoaded = false
    }
    init() {
        // Store handles to DOM
        this.$newsletter = document.querySelector('#newsletter')
        this.footerRegionsArr = document.querySelectorAll('.footer-menu__accordion-region')
        
        
        this.footerRegionsArr.forEach($region => {
            new Expandable($region)
        }) 
        
        new Expandable(this.$newsletter, {
            on: {
                open: () => {
                    this.$newsletter.removeAttribute('inert')
                    this.newsletterTrapFocus = trapFocus(this.$newsletter)
                    
                    // if (this.newsletterFormIsLoaded === false) {
                    //     this.queryNewsletterForm()
                    //     this.newsletterFormIsLoaded = true
                    // }
                },
                close: () => {
                    this.$newsletter.setAttribute('inert', 'inert')
                    this.newsletterTrapFocus?.destroy()
                }
            }
        })
        
        // set listener...
        this.mobileDisplayQuery.addEventListener('change', this.onMobileDisplayQueryChange.bind(this), {capture: false, passive: true, once: false} || false)
        // ...then trigger it once
        this.onMobileDisplayQueryChange(this.mobileDisplayQuery)
        
        //COOKIES SETTINGS OPENER
        const openCookies = this.$el.querySelector('.open-cookies');
        if(openCookies) {
            
            openCookies.addEventListener('click', (e) => {
                e.preventDefault();
                if( typeof openAxeptioCookies === 'function'){
                    openAxeptioCookies();
                } 
            }, {capture: false, passive: false, once: false} || false );
            
        }
        
    }
    onMobileDisplayQueryChange(e) {
        if (e.matches === true) {
            this.footerRegionsArr.forEach(_$region => {
                _$region.expandable.enable()
                _$region.expandable.close()
            })
        } else {
            this.footerRegionsArr.forEach(_$region => {
                _$region.expandable.open()
                _$region.expandable.disable()
            })
        }
    }
    
    
    async betterFetch(url) {
        return fetch(url)
            .then(response => {
                if (response.ok) return response.json()
                else {
                    /* An error has occured */
                    return response.json()
                        .catch(() => {
                            /* Couldn't parse the JSON */
                            return response.status
                        })
                        .then(({message}) => {
                            /* Got valid JSON with error response, use it */
                            console.error(`Got valid JSON with error response "${message || response.status}". (URL: ${url})`)
                            // throw new Error(message || response.status);
                            return {httpCode: response.status, errorMessage: message}
                        })
                }
            })
            .catch(error => error)
    }
    async queryNewsletterForm() {
        const origin = window.location.origin
        const endpoint = '/wp-json/piper-heidsieck/v1/newsletter-form/'
        const url = new URL(`${origin}${endpoint}`)
        const response = await this.betterFetch(url)
        // console.log(response)
        const fallback = '<strong style="color: var(--theme--pure-black--50);">An error occured, please reload the page</strong>'
        
        if (response.data) {
            // const currentSlug = window.location.pathname
            // console.log(currentSlug)
            // const formStr = response.data.replace(endpoint, currentSlug)
            document.body.querySelector('#newsletter-modal__landing-strip').innerHTML += formStr
            
        } else {
            document.body.querySelector('#newsletter-modal__landing-strip').innerHTML += fallback
        }
    }
}


    
    